export default "__VITE_ASSET__CLM8vesA__"